module.exports = __webpack_public_path__ + "static/media/Close.4b7b0b06.svg";